import { useState } from 'react'

import clsx from 'clsx'

import { useAudioPlayback } from '@livekit/components-react'

import { VolumeOff, VolumeOn } from '@/src/assets/icons'
import { useRoomContext } from '@/src/context'

import styles from './ToggleAudio.module.css'

export const ToggleAudio = () => {
  const room = useRoomContext()
  const { startAudio } = useAudioPlayback(room)
  const [isEnabledSound, setIsEnabledSound] = useState(() => room?.canPlaybackAudio)

  const handleToggleAudio = () => {
    if (!room?.canPlaybackAudio) {
      startAudio()
    } else {
      room.remoteParticipants.forEach((participant) => {
        participant.audioTrackPublications.forEach((track) => {
          track.setEnabled(!track?.isEnabled)
        })
      })
    }

    setIsEnabledSound((prev) => !prev)
  }

  return (
    <button
      type="button"
      aria-label="Toggler for sound"
      onClick={handleToggleAudio}
      className={clsx(styles?.button, 'lk-button')}
    >
      {isEnabledSound ? <VolumeOff /> : <VolumeOn />}
    </button>
  )
}
